class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  // Even with the modal visually flush to the screen edges, a touchmove
  // starting on background content (outside this element) can still scroll
  // the page underneath - overflow/height fixes on the modal itself don't
  // stop that. Block it directly, but only for touches outside the modal,
  // so scrolling the actual results list/suggestions inside still works.
  onTouchMove(event) {
    if (!this.contains(event.target)) {
      event.preventDefault();
    }
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.onTouchMoveEvent = this.onTouchMoveEvent || this.onTouchMove.bind(this);
    event.target.closest('details').setAttribute('open', true);
    // On mobile the search drawer fills the entire viewport, so there's no
    // visible "outside" to click - only wire up click-to-close on desktop,
    // where it's a smaller panel with real backdrop around it.
    if (!window.matchMedia('(max-width: 749px)').matches) {
      document.body.addEventListener('click', this.onBodyClickEvent);
    }
    document.addEventListener('touchmove', this.onTouchMoveEvent, { passive: false });
    this.scrollY = window.scrollY;
    document.documentElement.classList.add('search-drawer-open');
    document.body.classList.add('search-drawer-open');
    document.body.scroll(0, this.scrollY);

    // Testing: skip auto-focusing the input on mobile so the keyboard
    // doesn't open immediately - see if that avoids the sticky-header
    // breakage that only happens once the keyboard's up.
    if (window.matchMedia('(max-width: 749px)').matches) {
      trapFocus(this.detailsContainer.querySelector('[tabindex="-1"]'));
    } else {
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }

    if (
      window.PhlurNavDrawer &&
      typeof window.PhlurNavDrawer.close === 'function' &&
      (typeof window.PhlurNavDrawer.isOpen !== 'function' || window.PhlurNavDrawer.isOpen())
    ) {
      window.PhlurNavDrawer.close();
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.removeEventListener('touchmove', this.onTouchMoveEvent);
    document.documentElement.classList.remove('search-drawer-open');
    document.body.classList.remove('search-drawer-open');
    window.scrollTo(0, this.scrollY || 0);

    const searchModal = this.querySelector('.search-modal');
    const finishClose = () => {
      this.detailsContainer.removeAttribute('open');
      if (searchModal) searchModal.classList.remove('is-closing');
    };

    if (searchModal) {
      // Brief pause before the slide-out starts (not a slower animation -
      // the transition itself is still .25s, see .search-modal in
      // theme.scss) so the close doesn't feel like it's firing the instant
      // you click.
      setTimeout(() => {
        searchModal.classList.add('is-closing');
        searchModal.addEventListener('transitionend', finishClose, { once: true });
        // Fallback in case transitionend doesn't fire (e.g. no actual style
        // change, reduced motion) - matches the .25s transition-duration.
        setTimeout(finishClose, 300);
      }, 100);
    } else {
      finishClose();
    }
  }
}

customElements.define('details-modal', DetailsModal);
